import styled, { css } from "styled-components";
import {
    Grid,
    Button,
    CardActions,
    CardContent,
    TextField,
} from "@mui/material";

export const DialogItemWrapper = styled.div`
    position: absolute;
    top: 54px;
    right: 52px;
    display: flex;
    align-items: center;
`;

export const DialogItem = styled.div`
    position: fixed;
    z-index: 1000;
    right: auto;
    top: auto;
`;

export const DialogQuestionWrapper = styled.div`
    position: absolute;
    top: 68px;
    right: 0;
    display: flex;
    align-items: center;
`;

export const Dialog = styled.div`
    position: fixed;
    z-index: 1000;
    right: auto;
    top: auto;
`;

export const EmojiButton = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 32px;
    height: 32px;
    padding: 0;
    line-height: 1;
`;

export const ShowEmojisButton = styled.button`
    background-image: url(/images/show-emojis.svg);
    background-color: transparent;
    outline: none;
    border: none;
    height: 30px;
    width: 30px;
`;

export const StyledFormWrapper = styled.div``;

export const StyledForm = styled.form`
    margin-bottom: 20px;
    @media (min-width: 768px) {
        padding: 0 16px 0 0;
    }
    overflow-y: auto;
`;
export const QuestionWarpper = styled.div`
    position: relative;
    margin-bottom: 30px;
`;

export const MultiVotingHint = styled.div(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        font-size: 0.875rem;
        color: ${theme.palette.common.darkGray};

        svg {
            margin-right: 8px;
            color: ${theme.palette.common.cyan};
        }
    `
);

export const StyledCardContent = styled(CardContent)(
    ({ theme }) => css`
        &.MuiCardContent-root {
            padding-bottom: 40px;
        }
    `
);

export const StyledCardActions = styled(CardActions)(
    ({ theme }) => css`
        list-style: none;
        width: 100%;
        z-index: 0;
        box-sizing: border-box;
        &:before {
            height: 3px;
            content: "";
            margin: 0 16px;
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: -1;
            border-radius: inherit;
            background: ${theme.palette.common.cyan};
            background: linear-gradient(
                90deg,
                ${theme.palette.common.pink} 0%,
                ${theme.palette.common.purple} 50%,
                ${theme.palette.common.cyan} 100%
            );
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="${theme
                .palette.common.pink}",endColorstr="${theme.palette.common
                .cyan}",GradientType=1);
        }
        &.MuiCardActions-root {
            padding: 16px;
            position: relative;
            div {
                display: flex;
                flex-wrap: wrap;
            }
        }
    `
);

export const StyledActionsWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

export const StyledQuestionField = styled(TextField)(
    ({ theme }) => css`
        & .MuiInput-root {
            height: 41px;
            color: ${theme.palette.common.darkGray};
        }
        & .MuiInputLabel-root {
            color: ${theme.palette.common.darkGray};
            font-size: 16px;
            line-height: 1.4;
            font-weight: 400;
        }
        & .MuiInputLabel-root.Mui-focused {
            color: ${theme.palette.common.blue};
        }
        & .MuiInput-underline:after {
            border-color: ${theme.palette.common.blue};
        }
        & .MuiInput-underline:hover:not(.Mui-disabled):before {
            border-color: ${theme.palette.common.blue};
        }
    `
);

export const StyledButton = styled(Button)(
    ({ theme }) => css`
        & > span {
            margin-left: 8px;
            color: ${theme.palette.common.darkGray};
            font-size: 16px;
            font-weight: 400;
            text-transform: capitalize;
            white-space: nowrap;
        }
    `
);

export const StyledSubmitButton = styled(Button)(
    ({ theme }) => css`
        &.MuiButton-root {
            background-color: ${theme.palette.common.cyan};
            color: ${theme.palette.common.white};
            text-transform: capitalize;
            border-radius: 100px;
            font-size: 18px;
            font-weight: 700;
            line-height: 1.5;
            padding: 8px 24px;
            &:hover {
                background-color: ${theme.palette.common.gray};
            }
        }
    `
);

export const StyledOptionWrapper = styled.div`
    display: grid;
    width: 100%;
    grid-template-columns: 1fr 52px;
    margin: 16px 0 0;
    position: relative;
`;

export const StyledOption = styled.div`
    position: relative;
    margin-bottom: 20px;
`;

export const StyledDeleteOption = styled(Button)`
    &.MuiButton-root {
        position: absolute;
        padding: 6px 0;
        min-width: 24px;
        top: 11px;
        z-index: 1;
    }
`;

export const StyledGrid = styled(Grid)(
    ({ theme }) => css`
        > * {
            &:nth-child(n + 3) {
                & .MuiInputLabel-root {
                    padding-left: 28px;
                }
                & .MuiInput-root {
                    padding-left: 28px;
                }
            }
        }
    `
);

export const StyledOptionField = styled(TextField)(
    ({ theme }) => css`
        & .MuiInput-root {
            color: ${theme.palette.common.darkGray};
        }
        & .MuiInputLabel-root {
            color: ${theme.palette.common.darkGray};
            font-size: 16px;
            line-height: 1.4;
            font-weight: 400;
        }
        & .MuiInputLabel-root.Mui-focused {
            color: ${theme.palette.common.blue};
        }
        & .MuiInput-underline:after {
            border-color: ${theme.palette.common.blue};
        }
        & .MuiInput-underline:hover:not(.Mui-disabled):before {
            border-color: ${theme.palette.common.blue};
        }
    `
);

export const ChannelIcon = styled.img`
    height: 30px;
    width: 30px;
    margin-right: 10px;
`;

export const ChannelWrapper = styled.div`
    display: flex;
    align-items: flex-end;
`;

export const SubmitDialog = styled(Button)(
    ({ theme }) => css`
        &.MuiButton-root {
            background-color: ${theme.palette.common.cyan};
            color: ${theme.palette.common.white};
            text-transform: capitalize;
            border-radius: 50%;
            font-size: 18px;
            font-weight: 700;
            line-height: 1.5;
            padding: 8px 24px;
            height: 60px;
            width: 60px;
            position: fixed;
            bottom: 20px;
            right: 16px;
            z-index: 9;
            &:hover {
                background-color: ${theme.palette.common.gray};
            }
        }
    `
);
